import Client from './Clients/AxiosClient';

const resource = '/api/UserAccount';

// Administrator-only user account maintenance. Both endpoints are gated on the API by the
// UserAccountAdministration policy (HQ Administrator / Kerawang Administrator), so the UI gate
// in MyStaffs.vue is a convenience, not the security boundary.
export default {
  // Replaces the target user's password. The API always revokes the target's existing sessions
  // as part of this, because ASP.NET Identity rotates the security stamp on a password change.
  changePassword({ primeUserId, newPassword, confirmPassword }) {
    return Client.post(`${resource}/change-password`, {
      primeUserId: primeUserId,
      newPassword: newPassword,
      confirmPassword: confirmPassword,
    });
  },

  // Signs the target user out of every device without touching their password.
  revokeSessions({ primeUserId }) {
    return Client.post(`${resource}/revoke-sessions`, {
      primeUserId: primeUserId,
    });
  },
};
